// @flow
import $ from 'jquery';
import JQueryView, { on } from '../common/JQueryView';

export default class LandingPageView extends JQueryView {
  autoToggleAbilityId: IntervalID;
  currentAbilityItem: number;
  constructor() {
    super('body');

    this.currentAbilityItem = 3;
    this._autoToggleAbility();
  }

  _autoToggleAbility = () => {
    this._nextToggleAbility(); // setIntervalは10秒後に初めて実行されるので、こちらで初回実行する
    this.autoToggleAbilityId = setInterval(() => {
      this._nextToggleAbility();
    }, 10000);
  };

  _nextToggleAbility = () => {
    const openTarget = $('.ability-list-item')
      .filter(':visible')
      .eq(this.currentAbilityItem);
    this._toggleAbility(openTarget);

    if (this.currentAbilityItem == 4) {
      this.currentAbilityItem = 0;
    } else {
      this.currentAbilityItem++;
    }
  };

  _toggleAbility = (openTarget: any) => {
    const targets = openTarget.parent().find('.ability-list-item');
    const images = targets
      .parents('.ability-list')
      .find('.ability-list-images');
    const smallImages = targets.parent().find('.ability-list-image-area');

    const openTargetIndex = targets.index(openTarget);

    const closeTarget = targets.not(openTarget);
    const openArrow = openTarget.find('.ability-list-item-arrow .icon');
    const closeArrow = closeTarget.find('.ability-list-item-arrow .icon');
    const openImage = images.eq(openTargetIndex);
    const closeImage = images.not(openImage);
    const openSmallImage = smallImages.eq(openTargetIndex);
    const closeSmallImage = smallImages.not(openSmallImage);

    closeTarget.removeClass('open');
    openTarget.addClass('open');

    closeTarget.find('a').slideUp('fast');
    openTarget.find('a').slideDown('fast');
    closeArrow.removeClass('ion-chevron-up').addClass('ion-chevron-down');
    openArrow.removeClass('ion-chevron-down').addClass('ion-chevron-up');

    closeImage.fadeOut('fast');
    openImage.fadeIn('fast');
    closeSmallImage.slideUp('fast');
    openSmallImage.slideDown('fast');
  };

  @on({ event: 'click', selector: '.ability-list-item' })
  clickToggleAbility(e: any) {
    clearInterval(this.autoToggleAbilityId);
    const openTarget = $(e.currentTarget);
    this._toggleAbility(openTarget);
  }

  @on({ event: 'click', selector: '#movie_thumb' })
  clickMovieThumbnail() {
    const videoId = $('#movie_thumb').data('video');
    $('#movie_thumb').html(
      `<iframe class="embed-responsive-item" src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&controls=1" frameborder="0"></iframe>`,
    );
  }

  @on({ event: 'click', selector: '.question-area' })
  clickToggleAccordion(e: any) {
    const openTarget = $(e.currentTarget).find('dt');
    const circleMark = $(e.currentTarget).find('.circle-mark');

    openTarget.next().slideToggle('fast');
    if (openTarget.hasClass('open')) {
      circleMark.text('＋');
      openTarget.removeClass('open');
    } else {
      circleMark.text('ー');
      openTarget.addClass('open');
    }
  }
}
